

















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPCapability, VipCapabilityStatus } from "@/loader";

@Component
export default class CapabilityStatusBadge extends Vue {
	@Prop({ type: VIPCapability, default: null })
	public item!: VIPCapability | null;

	@Prop({ type: Boolean, default: false })
	public fullText!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideText!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideIcon!: boolean;

	@Prop({ type: Boolean, default: false })
	public button!: boolean;

	@Prop({ type: [String, Object], default: null })
	public to!: string | Location | null;

	public get title(): string {
		return this.item ? this.item.getTypeLabel() + " " + this.item.getStatusLabel() + (this.item.isRenewable ? " Renouvellable" : "") : "";
	}

	public get icon(): string | string[] | null {
		// if (this.item?.isExpired) {
		// 	return ["fas", "times"];
		// }
		switch (this.item?.status) {
			case VipCapabilityStatus.sent:
				return ["far", "envelope"];
			case VipCapabilityStatus.refused:
				return ["far", "minus-circle"];
			case VipCapabilityStatus.signed:
				return ["fas", "check"];
			case VipCapabilityStatus.expired:
				return ["far", "clock"];
			case VipCapabilityStatus.archived:
				return ["far", "calendar-check"];
			case VipCapabilityStatus.draft:
			default:
				return ["fas", "edit"];
		}
	}

	public get statusVariant(): string {
		let prefix = this.item?.isTypeCustomary ? "" : "outline-";
		switch (this.item?.status) {
			case VipCapabilityStatus.signed:
				return prefix + "success";
			case VipCapabilityStatus.sent:
				return prefix + "warning";
			case VipCapabilityStatus.refused:
				return prefix + "danger";
			case VipCapabilityStatus.expired:
				return prefix + "danger";
			case VipCapabilityStatus.archived:
				return prefix + "secondary";
			case VipCapabilityStatus.draft:
			default:
				return prefix + "info";
		}
	}
}
